import React, { Fragment } from 'react';

import { normalizeNameOfPerson } from '../../../../../../utils/normalize/normalizeNameOfPerson';

// Components

import SummaryItem from '../SummaryItem';

const AdditionalInformationInfo = props => {

    const {
        idx,
        healthCoverage: {
            eligibleITU,
            receivedITU,
            unpaidBill,
            absentParent
        },
        name
    } = props;

    let customerName = normalizeNameOfPerson(name);

    return (
        <Fragment>
            {
                eligibleITU !== null &&

                <SummaryItem
                    category='ssap.additional_info.summary.eligible_for_tribal_program'
                    value={ eligibleITU }
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ idx }].healthCoverage.eligibleITU`
                            ]
                        ]
                    }
                />
            }
            {
                receivedITU !== null &&

                <SummaryItem
                    category='ssap.additional_info.summary.services_from_tribal_program'
                    value={ receivedITU }
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ idx }].healthCoverage.receivedITU`
                            ]
                        ]
                    }
                />
            }
            {
                unpaidBill !== null &&

                <SummaryItem
                    category='ssap.additional_info.summary.medical_bills'
                    value={ unpaidBill }
                    replacements={{ personName: customerName }}
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ idx }].healthCoverage.unpaidBill`
                            ]
                        ]
                    }
                />
            }
            {
                absentParent !== null &&

                <SummaryItem
                    category='ssap.additional_info.summary.parents_live_outside'
                    value={ absentParent }
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ idx }].healthCoverage.absentParent`
                            ]
                        ]
                    }
                />
            }
        </Fragment>
    );
};

export default AdditionalInformationInfo;